module.exports = ":host::ng-deep {\r\n    max-width: 100%;\r\n    display: block;\r\n}\r\n\r\n.tag-button {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: calc(100% - 5px);\r\n}\r\n\r\n.tag-none {\r\n    display: none;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/o-button/button-tags/button-tags.component.css
// module id = ./src/app/commons/o-button/button-tags/button-tags.component.css
// module chunks = main